import React, { useState, useEffect } from 'react';
import { get } from '../../helpers/apiHelper';
import { FaTimes, FaSave, FaPlus, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import ofertasService from '../../helpers/ofertasService';

const CrearOfertaModal = ({ isOpen, onClose, oferta = null, onSuccess }) => {
    // Estado inicial con valores por defecto seguros
    const getInitialFormData = () => ({
        nombre: '',
        descripcion: '',
        tipo: 'DESCUENTO_PORCENTAJE',
        marca: '',
        objetivoPrincipal: 'AUMENTAR_VENTAS',
        fechaInicio: '',
        fechaFin: '',
        aplicabilidad: 'AMBOS',
        // canalesDifusion: [], // TODO: Implementar en backend
        mensajePromocional: '',
        callToAction: '',
        etiquetas: [],
        porcentajeDescuento: 0,
        descuentoFijo: 0,
        importeMinimo: 0,
        // importeMinimoGratis: 0, // TODO: Implementar envío gratis en backend
        usosMaximosGlobales: 1,
        usosMaximosPorCliente: 1,
        // segmentos: [], // TODO: Implementar en backend
        // productos: [], // TODO: Implementar en backend
        cantidadMinima: 1,
        importeMaximo: 0
        // imagenUrl: '', // TODO: Implementar en backend
        // landingUrl: '', // TODO: Implementar en backend
        // activarPopup: false // TODO: Implementar en backend
    });

    const [formData, setFormData] = useState(getInitialFormData());

    const [marcas, setMarcas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [etiquetaInput, setEtiquetaInput] = useState('');

    // Usar el servicio para obtener las opciones
    const tiposOferta = ofertasService.getTiposOferta();
    const objetivos = ofertasService.getObjetivos();
    const canalesDifusion = ofertasService.getCanalesDifusion();
    const aplicabilidades = ofertasService.getAplicabilidades();

    // Función helper para asegurar valores válidos
    const ensureValidValue = (value, defaultValue = '') => {
        if (value === null || value === undefined) {
            return defaultValue;
        }
        return value;
    };

    useEffect(() => {
        if (isOpen) {
            fetchMarcas();
            if (oferta) {
                setIsEditing(true);
                setFormData({
                    // Campos básicos con valores por defecto seguros
                    nombre: ensureValidValue(oferta.nombre),
                    descripcion: ensureValidValue(oferta.descripcion),
                    tipo: ensureValidValue(oferta.tipo, 'DESCUENTO_PORCENTAJE'),
                    // Extraer solo el ID de la marca si es un objeto
                    marca: typeof oferta.marca === 'object' ? ensureValidValue(oferta.marca._id) : ensureValidValue(oferta.marca),
                    objetivoPrincipal: ensureValidValue(oferta.objetivoPrincipal, 'AUMENTAR_VENTAS'),
                    aplicabilidad: ensureValidValue(oferta.aplicabilidad, 'AMBOS'),
                    mensajePromocional: ensureValidValue(oferta.mensajePromocional),
                    callToAction: ensureValidValue(oferta.callToAction),
                    // imagenUrl: ensureValidValue(oferta.imagenUrl), // TODO: Implementar en backend
                    // landingUrl: ensureValidValue(oferta.landingUrl), // TODO: Implementar en backend
                    // Fechas
                    fechaInicio: oferta.fechaInicio ? new Date(oferta.fechaInicio).toISOString().split('T')[0] : '',
                    fechaFin: oferta.fechaFin ? new Date(oferta.fechaFin).toISOString().split('T')[0] : '',
                    // Arrays
                    etiquetas: Array.isArray(oferta.etiquetas) ? oferta.etiquetas : [],
                    // canalesDifusion: Array.isArray(oferta.canalesDifusion) ? oferta.canalesDifusion : [], // TODO: Implementar en backend
                    // segmentos: Array.isArray(oferta.segmentos) ? oferta.segmentos : [], // TODO: Implementar en backend
                    // productos: Array.isArray(oferta.productos) ? oferta.productos : [], // TODO: Implementar en backend
                    // Números
                    porcentajeDescuento: ensureValidValue(oferta.porcentajeDescuento, 0),
                    descuentoFijo: ensureValidValue(oferta.descuentoFijo, 0),
                    importeMinimo: ensureValidValue(oferta.importeMinimo, 0),
                    // importeMinimoGratis: ensureValidValue(oferta.importeMinimoGratis, 0), // TODO: Implementar envío gratis en backend
                    importeMaximo: ensureValidValue(oferta.importeMaximo, 0),
                    usosMaximosGlobales: ensureValidValue(oferta.usosMaximosGlobales, 1),
                    usosMaximosPorCliente: ensureValidValue(oferta.usosMaximosPorCliente, 1),
                    cantidadMinima: ensureValidValue(oferta.cantidadMinima, 1)
                    // Booleanos
                    // activarPopup: Boolean(oferta.activarPopup) // TODO: Implementar en backend
                });
            } else {
                setIsEditing(false);
                setFormData(getInitialFormData());
            }
        }
    }, [isOpen, oferta]);

    const fetchMarcas = async () => {
        try {
            const response = await get('marcas');
            setMarcas(response);
        } catch (error) {
            console.error('Error cargando marcas:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            // TODO: Implementar canales de difusión en el backend
            // if (name === 'canalesDifusion') {
            //     const updatedCanales = checked
            //         ? [...formData.canalesDifusion, value]
            //         : formData.canalesDifusion.filter(canal => canal !== value);
            //     setFormData(prev => ({ ...prev, canalesDifusion: updatedCanales }));
            // } else {
            setFormData(prev => ({ ...prev, [name]: checked }));
            // }
        } else if (type === 'number') {
            setFormData(prev => ({ ...prev, [name]: parseFloat(value) || 0 }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value || '' }));
        }
    };

    const handleAddEtiqueta = () => {
        if (etiquetaInput.trim() && !formData.etiquetas.includes(etiquetaInput.trim())) {
            setFormData(prev => ({
                ...prev,
                etiquetas: [...prev.etiquetas, etiquetaInput.trim()]
            }));
            setEtiquetaInput('');
        }
    };

    const handleRemoveEtiqueta = (etiquetaToRemove) => {
        setFormData(prev => ({
            ...prev,
            etiquetas: prev.etiquetas.filter(etiqueta => etiqueta !== etiquetaToRemove)
        }));
    };

    const handleEtiquetaKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddEtiqueta();
        }
    };

    const cleanFormData = (data) => {
        // Crear un objeto limpio con solo los campos válidos
        const cleanData = {
            nombre: data.nombre,
            descripcion: data.descripcion,
            tipo: data.tipo,
            marca: data.marca,
            objetivoPrincipal: data.objetivoPrincipal,
            fechaInicio: data.fechaInicio,
            fechaFin: data.fechaFin,
            aplicabilidad: data.aplicabilidad,
            // canalesDifusion: data.canalesDifusion, // TODO: Implementar en backend
            mensajePromocional: data.mensajePromocional,
            callToAction: data.callToAction,
            etiquetas: data.etiquetas,
            usosMaximosPorCliente: data.usosMaximosPorCliente,
            usosMaximosGlobales: Math.max(data.usosMaximosGlobales, 1)
        };

        // Agregar campos específicos según el tipo de oferta
        switch (data.tipo) {
            case 'DESCUENTO_PORCENTAJE':
                cleanData.porcentajeDescuento = data.porcentajeDescuento;
                if (data.importeMinimo > 0) {
                    cleanData.importeMinimo = data.importeMinimo;
                }
                if (data.importeMaximo > 0) {
                    cleanData.importeMaximo = data.importeMaximo;
                }
                break;
            case 'DESCUENTO_FIJO':
                cleanData.descuentoFijo = data.descuentoFijo;
                if (data.importeMinimo > 0) {
                    cleanData.importeMinimo = data.importeMinimo;
                }
                if (data.importeMaximo > 0) {
                    cleanData.importeMaximo = data.importeMaximo;
                }
                break;
            case 'DOS_POR_UNO':
                // TODO: Implementar productos en backend
                // if (data.productos && data.productos.length > 0) {
                //     cleanData.productos = data.productos;
                // }
                if (data.cantidadMinima > 0) {
                    cleanData.cantidadMinima = data.cantidadMinima;
                }
                break;
            // TODO: Implementar envío gratis en backend
            // case 'ENVIO_GRATIS':
            //     if (data.importeMinimoGratis > 0) {
            //         cleanData.importeMinimoGratis = data.importeMinimoGratis;
            //     }
            //     break;
        }

        // Agregar campos opcionales si tienen valor
        // TODO: Implementar en backend
        // if (data.imagenUrl) {
        //     cleanData.imagenUrl = data.imagenUrl;
        // }
        // if (data.landingUrl) {
        //     cleanData.landingUrl = data.landingUrl;
        // }
        // if (data.activarPopup) {
        //     cleanData.activarPopup = data.activarPopup;
        // }

        return cleanData;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar datos usando el servicio
        const validation = ofertasService.validateOfertaData(formData);
        if (!validation.isValid) {
            Swal.fire('Error', validation.errors.join(', '), 'error');
            return;
        }

        setLoading(true);
        try {
            // Limpiar los datos antes de enviar
            const cleanData = cleanFormData(formData);
            console.log('Datos a enviar:', cleanData);

            const response = isEditing
                ? await ofertasService.updateOferta(oferta._id, cleanData)
                : await ofertasService.createOferta(cleanData);

            Swal.fire(
                'Éxito',
                `Oferta ${isEditing ? 'actualizada' : 'creada'} correctamente`,
                'success'
            );

            onSuccess(response);
            onClose();
        } catch (error) {
            console.error('Error guardando oferta:', error);
            Swal.fire('Error', error.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="flex items-center justify-between p-6 border-b">
                    <h2 className="text-xl font-bold text-gray-800">
                        {isEditing ? 'Editar Oferta' : 'Crear Nueva Oferta'}
                    </h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <FaTimes size={20} />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Información básica */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Nombre de la Oferta *
                            </label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Ej: Descuento Verano 20%"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Marca *
                            </label>
                            <select
                                name="marca"
                                value={formData.marca}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                <option value="">Seleccionar marca</option>
                                {marcas.map(marca => (
                                    <option key={marca._id} value={marca._id}>
                                        {marca.nombre || marca.displayName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Descripción *
                            </label>
                            <textarea
                                name="descripcion"
                                value={formData.descripcion}
                                onChange={handleInputChange}
                                rows="3"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Describe la oferta..."
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Tipo de Oferta *
                            </label>
                            <select
                                name="tipo"
                                value={formData.tipo}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                {tiposOferta.map(tipo => (
                                    <option key={tipo.value} value={tipo.value}>
                                        {tipo.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Objetivo Principal
                            </label>
                            <select
                                name="objetivoPrincipal"
                                value={formData.objetivoPrincipal}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                {objetivos.map(objetivo => (
                                    <option key={objetivo.value} value={objetivo.value}>
                                        {objetivo.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Aplicabilidad
                            </label>
                            <select
                                name="aplicabilidad"
                                value={formData.aplicabilidad}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                                {aplicabilidades.map(aplicabilidad => (
                                    <option key={aplicabilidad.value} value={aplicabilidad.value}>
                                        {aplicabilidad.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Campos específicos del tipo */}
                        {formData.tipo === 'DESCUENTO_PORCENTAJE' && (
                            <>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Porcentaje de Descuento (%)
                                    </label>
                                    <input
                                        type="number"
                                        name="porcentajeDescuento"
                                        value={formData.porcentajeDescuento}
                                        onChange={handleInputChange}
                                        min="1"
                                        max="100"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Importe Mínimo (€)
                                    </label>
                                    <input
                                        type="number"
                                        name="importeMinimo"
                                        value={formData.importeMinimo}
                                        onChange={handleInputChange}
                                        min="0"
                                        step="0.01"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Importe Máximo (€)
                                    </label>
                                    <input
                                        type="number"
                                        name="importeMaximo"
                                        value={formData.importeMaximo}
                                        onChange={handleInputChange}
                                        min="0"
                                        step="0.01"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Sin límite si se deja en 0"
                                    />
                                </div>
                            </>
                        )}

                        {formData.tipo === 'DESCUENTO_FIJO' && (
                            <>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Descuento Fijo (€)
                                    </label>
                                    <input
                                        type="number"
                                        name="descuentoFijo"
                                        value={formData.descuentoFijo}
                                        onChange={handleInputChange}
                                        min="0"
                                        step="0.01"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Importe Mínimo (€)
                                    </label>
                                    <input
                                        type="number"
                                        name="importeMinimo"
                                        value={formData.importeMinimo}
                                        onChange={handleInputChange}
                                        min="0"
                                        step="0.01"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Importe Máximo (€)
                                    </label>
                                    <input
                                        type="number"
                                        name="importeMaximo"
                                        value={formData.importeMaximo}
                                        onChange={handleInputChange}
                                        min="0"
                                        step="0.01"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        placeholder="Sin límite si se deja en 0"
                                    />
                                </div>
                            </>
                        )}

                        {formData.tipo === 'DOS_POR_UNO' && (
                            <>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Cantidad Mínima
                                    </label>
                                    <input
                                        type="number"
                                        name="cantidadMinima"
                                        value={formData.cantidadMinima}
                                        onChange={handleInputChange}
                                        min="2"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                {/* TODO: Implementar selección de productos en backend */}
                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Productos Aplicables
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="IDs de productos separados por comas"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        readOnly
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        Nota: La selección de productos se implementará en futuras versiones
                                    </p>
                                </div> */}
                            </>
                        )}

                        {/* TODO: Implementar envío gratis en backend */}
                        {/* {formData.tipo === 'ENVIO_GRATIS' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Importe Mínimo para Envío Gratis (€)
                                </label>
                                <input
                                    type="number"
                                    name="importeMinimoGratis"
                                    value={formData.importeMinimoGratis}
                                    onChange={handleInputChange}
                                    min="0"
                                    step="0.01"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                        )} */}

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Fecha de Inicio *
                            </label>
                            <input
                                type="date"
                                name="fechaInicio"
                                value={formData.fechaInicio}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Fecha de Fin *
                            </label>
                            <input
                                type="date"
                                name="fechaFin"
                                value={formData.fechaFin}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Usos Máximos Globales
                            </label>
                            <input
                                type="number"
                                name="usosMaximosGlobales"
                                value={formData.usosMaximosGlobales}
                                onChange={handleInputChange}
                                min="1"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Mínimo 1 uso"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Usos Máximos por Cliente
                            </label>
                            <input
                                type="number"
                                name="usosMaximosPorCliente"
                                value={formData.usosMaximosPorCliente}
                                onChange={handleInputChange}
                                min="1"
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            />
                        </div>

                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Mensaje Promocional
                            </label>
                            <input
                                type="text"
                                name="mensajePromocional"
                                value={formData.mensajePromocional}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Ej: ¡Verano con 20% OFF!"
                            />
                        </div>

                        {/* TODO: Implementar canales de difusión en el backend */}
                        {/* <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Canales de Difusión
                            </label>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                {canalesDifusion.map(canal => (
                                    <label key={canal.value} className="flex items-center">
                                        <input
                                            type="checkbox"
                                            name="canalesDifusion"
                                            value={canal.value}
                                            checked={formData.canalesDifusion.includes(canal.value)}
                                            onChange={handleInputChange}
                                            className="mr-2"
                                        />
                                        <span className="text-sm text-gray-700">{canal.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div> */}

                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Call to Action
                            </label>
                            <input
                                type="text"
                                name="callToAction"
                                value={formData.callToAction}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="Ej: Comprar Ahora, Aprovechar Oferta"
                            />
                        </div>

                        <div className="md:col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Etiquetas
                            </label>
                            <div className="space-y-2">
                                <div className="flex space-x-2">
                                    <input
                                        type="text"
                                        value={etiquetaInput}
                                        onChange={(e) => setEtiquetaInput(e.target.value)}
                                        onKeyPress={handleEtiquetaKeyPress}
                                        placeholder="Agregar etiqueta..."
                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                    <button
                                        type="button"
                                        onClick={handleAddEtiqueta}
                                        className="px-3 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 flex items-center"
                                    >
                                        <FaPlus size={14} />
                                    </button>
                                </div>
                                {formData.etiquetas.length > 0 && (
                                    <div className="flex flex-wrap gap-2">
                                        {formData.etiquetas.map((etiqueta, index) => (
                                            <span
                                                key={index}
                                                className="inline-flex items-center px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded-full"
                                            >
                                                {etiqueta}
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveEtiqueta(etiqueta)}
                                                    className="ml-1 text-blue-600 hover:text-blue-800"
                                                >
                                                    <FaTrash size={10} />
                                                </button>
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* TODO: Implementar URLs en el backend */}
                        {/* <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                URL de Imagen
                            </label>
                            <input
                                type="url"
                                name="imagenUrl"
                                value={formData.imagenUrl}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="https://ejemplo.com/imagen.jpg"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                URL de Landing
                            </label>
                            <input
                                type="url"
                                name="landingUrl"
                                value={formData.landingUrl}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                placeholder="https://ejemplo.com/landing"
                            />
                        </div> */}

                        {/* TODO: Implementar popup automático en el backend */}
                        {/* <div className="md:col-span-2">
                            <label className="flex items-center">
                                <input
                                    type="checkbox"
                                    name="activarPopup"
                                    checked={formData.activarPopup}
                                    onChange={handleInputChange}
                                    className="mr-2"
                                />
                                <span className="text-sm text-gray-700">Activar popup automático</span>
                            </label>
                        </div> */}
                    </div>

                    <div className="flex justify-end space-x-3 pt-6 border-t mt-6">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
                        >
                            <FaSave className="mr-2" />
                            {loading ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CrearOfertaModal; 